const MODAL_MODULE_PROVIDERS = [];

export {MODAL_MODULE_PROVIDERS};
